import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useNavigate, useParams } from '@exam-management/router';
import { AddRoundedIcon, Button, DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';
import { WithPermission } from '@shared/permissions';

export function QConfigGeneratorListNoRowsOverlay() {
  const { courseId } = useParams('/exam-courses/:courseId/qconfig-generators');
  const navigate = useNavigate();

  return (
    <NoRowsOverlay
      icon={DescriptionOutlinedIcon}
      title='ยังไม่มี QConfig Generator'
      description='คลิกปุ่มด้านล่างเพื่อเพิ่ม QConfig Generator ใหม่'
      action={
        <WithPermission requiredPermission={APP_PERMISSIONS.EXAM.QCONFIG.CREATE}>
          <Button
            variant='outlined'
            size='large'
            startIcon={<AddRoundedIcon />}
            onClick={() =>
              navigate('/exam-courses/:courseId/qconfig-generators/create', {
                params: { courseId },
              })
            }
          >
            Gen QConfig
          </Button>
        </WithPermission>
      }
    />
  );
}
